import { useState } from 'react';
import { Typography, IconButton, Box } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import { useTheme } from '@emotion/react';
import styles from './style';
import useLocalStorage from '../../hooks/useLocalStorage';
import { handleSimTypeUpdate } from './simtypeSelector.util';
import CheckoutESIMDetails from './checkoutESIMDetails';
import ESIMTooltip from './eSIMTooltip';
import tooltipicon from '../../../public/icons/Vector.png';
import { getCookie } from '../../hooks/useCookie';
import ErrorModal from '../eir-error-modal/ErrorModal';
import { useToggle } from '../../hooks/useToggle';

const CheckoutSimSelector = ({
  SIMType,
  setCartAfterSIMupdate,
  offerId,
  SIMOnly,
  cmsData,
  pSIMCode,
  SIMCardType,
}) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const localStore = useLocalStorage();

  const [enableESIMDetails, setEnableESIMDetails] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const updateSIMErrorModal = useToggle(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleToggle = async () => {
    const cartData = await handleSimTypeUpdate({
      SIMType: SIMType === 'ALL_IN_1' ? 'ESIM' : 'ALL_IN_1',
      offerId,
      offerCode: '',
      graphql,
      localStore,
      url: getCookie('cart_Type') === 'CROSS_SELL' ? '/shop/impact-summary' : '/shop/summary',
    });
    if (cartData) {
      setCartAfterSIMupdate(cartData);
      const updatedSIMCode = cartData?.cart.filter(res => res.offerId === offerId)[0]?.SIMCode;
      setEnableESIMDetails(SIMOnly && updatedSIMCode !== pSIMCode);
    } else {
      updateSIMErrorModal.enable();
    }
  };

  // if (selectedSim === 'eSIM') {
  //   return (
  //     <Typography variant='body1' sx={styles(theme).SimText}>
  //       eSIM only device
  //     </Typography>
  //   );
  // }

  return (
    <>
      {(SIMCardType === 'HYBRID' || SIMOnly) && (
        <Box sx={styles(theme).checkoutSimContainer}>
          <Typography variant='body1' sx={styles(theme).SimText}>
            {SIMType === 'ALL_IN_1' ? 'Physical SIM - ' : 'eSIM - '}
          </Typography>
          <Typography
            variant='body1'
            sx={styles(theme).link}
            onClick={handleToggle}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle();
              }
            }}
            tabIndex={0}
          >
            {SIMType === 'ALL_IN_1' ? 'Change to eSIM' : 'Change to physical SIM'}
          </Typography>
          {SIMType === 'ALL_IN_1' && (
            <IconButton sx={styles(theme).iconButton} onClick={handleOpenModal}>
              <Box component='img' src={tooltipicon.src} alt='' sx={styles(theme).vectorIcon} />
            </IconButton>
          )}
          <ESIMTooltip open={isModalOpen} onClose={handleCloseModal} cmsData={cmsData} />
        </Box>
      )}
      {SIMCardType === 'ESIM' && (
        <Box sx={{ pt: '1rem' }}>
          <Typography variant='body1' sx={styles(theme).SimText}>
            eSIM only device
          </Typography>
        </Box>
      )}

      {enableESIMDetails && <CheckoutESIMDetails cmsData={cmsData} offerId={offerId} />}
      {updateSIMErrorModal.value && (
        <ErrorModal
          errorBBModal={updateSIMErrorModal}
          occurences={2}
          currentOccurence={1}
          ctaMethod={() => {
            updateSIMErrorModal.disable();
          }}
        />
      )}
    </>
  );
};
export default CheckoutSimSelector;
